export default "__VITE_ASSET__X79qFtJT__"